import {
  OrganizationType,
  v2OrganizationsScheduleDetail,
  type V2OrganizationsScheduleDetailParams,
} from '@on3/api';
import withAuthentication from '@on3/ui-lib/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/hocs/withValidUrl';
import { proxyApi } from '@on3/ui-lib/index';
import { baseSports } from '@on3/ui-lib/store/mocks/sports';
import { getFulfilledValue } from '@on3/ui-lib/utils/api';
import { getIdFromParam, getSportKeyFromParam } from '@on3/ui-lib/utils/url';
import {
  type IHighSchoolScheduleProps,
  SchedulePage,
} from '@public/components/Schedules/HighSchool/SchedulePage';
import { type AxiosError } from 'axios';
import { type GetServerSideProps } from 'next';

const HighSchoolSchedulePage = (props: IHighSchoolScheduleProps) => {
  return <SchedulePage {...props} />;
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const highSchoolSiteKey = 402;
  const siteData = await withValidUrl.isValid(ctx, highSchoolSiteKey);
  const userData = await withAuthentication.isAuth(ctx);
  const { sport = 'football', id } = ctx.query as { id: string; sport: string };

  const orgKey = getIdFromParam(id);
  const sportKey = getSportKeyFromParam(sport);

  if (!siteData || !orgKey || !sportKey) {
    return {
      notFound: true,
    };
  }

  const params: V2OrganizationsScheduleDetailParams = {
    sportKey,
    year: siteData.defaultYears.highSchoolYear,
    orgKey,
  };

  try {
    const [schedule] = await Promise.allSettled([
      v2OrganizationsScheduleDetail(proxyApi, params),
    ]);

    const scheduleData = getFulfilledValue(schedule);

    const { relatedModel } = scheduleData || {};

    const orgType = relatedModel?.organization?.orgTypeEnum;
    const orgSlug = relatedModel?.organization?.urlSlug;

    if (orgType !== OrganizationType.HighSchool) {
      return { notFound: true };
    }

    if (id !== orgSlug) {
      return {
        redirect: {
          permanent: true,
          destination: `/high-school/${orgSlug}/${sport}/schedule/`,
        },
      };
    }

    const data = {
      pageType: 'database',
      siteData,
      userData,
      schedule: scheduleData,
      filters: {
        years: [2023, 2024, 2025, 2026],
        sports: baseSports,
      },
    };

    return { props: { ...data } };
  } catch (error) {
    const err: AxiosError<unknown> = error as AxiosError<unknown>;

    console.error(err);

    return { props: {} };
  }
};

export default withValidUrl(HighSchoolSchedulePage);
